import { render, staticRenderFns } from "./CustomerActionForceMassDeleteDialog.vue?vue&type=template&id=31c51254&"
import script from "./CustomerActionForceMassDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./CustomerActionForceMassDeleteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports